// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { ITuitionForm } from '~/utils/mockData/common';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      studentId: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      studentName: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      name: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      paidDate: yup.string().trim().optional(),
    })
    .required();
};

export const defaultValuesForm: ITuitionForm = {
  studentId: '',
  studentName: '',
  name: '',
};
